"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formatFraction = _interopRequireDefault(require("../utils/formatFraction"));

var _default = _react.default.createClass({
  displayName: "FormattedFraction",
  propTypes: {
    numerator: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired,
    denominator: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
  },
  render: function render() {
    var _this$props = this.props,
        numerator = _this$props.numerator,
        denominator = _this$props.denominator;
    return _react.default.createElement("span", null, (0, _formatFraction.default)({
      numerator: numerator,
      denominator: denominator
    }));
  }
});

exports.default = _default;
module.exports = exports.default;